/* Statiegeld gelijktrekken met het aantal 12 packs in de winkelwagen.

   Zelfde afspraak als op de live site (../../Website 2/statiegeld.js):
   statiegeld is een eigen product (handle `fee-rule`, €1,80 per 12 pack)
   dat in de winkelwagen en het totaal onzichtbaar blijft en pas in de
   checkout verschijnt. Het verbergen doet de Liquid (cart-drawer,
   main-cart-items, main-cart-footer, klaasje-cart-icon); dit script zorgt
   dat het aantal klopt.

   Wanneer: bij het laden van de pagina, na elke wijziging aan de mand
   (Dawn meldt die via PUB_SUB_EVENTS.cartUpdate) en nog één keer vers
   vlak voor het afrekenen. Doordat het al klopt voordat iemand op een
   knop drukt, gaat het ook goed bij Shop Pay en andere snelknoppen die
   de afrekenknop overslaan. Altijd eerst de mand vers ophalen en dan
   exact zetten: de lokale staat kan verouderd zijn (terug uit de
   checkout komt de pagina uit de bfcache, zie ververs()).

   Het statiegeld hoort in de checkout ónder de producten (eigenaar). De
   checkout neemt de volgorde van de mand over, en Shopify zet een nieuwe
   regel altijd bovenaan; een aantal wijzigen verplaatst een regel niet.
   Statiegeld komt dus alleen onderaan als het de óudste regel is. Staat
   het ergens anders, of ontbreekt het, dan bouwen we de mand opnieuw op:
   alles op 0 en dan in één verzoek eerst het statiegeld en daarna de
   producten in hun eigen volgorde (in een items-lijst komt de eerste
   onderaan te staan, gemeten op de preview).

   Een 12 pack herkennen we aan het producttype `Hard Seltzer`, niet aan
   de titel: zo telt een nieuwe smaak vanzelf mee. Er komen alleen 12 packs
   op de site (eigenaar), dus elk stuk is één keer statiegeld.

   Lukt gelijktrekken twee keer niet, dan gaat de klant toch door naar de
   checkout: een gemiste bestelling kost meer dan ontbrekend statiegeld. */
(function () {
  var script = document.currentScript;
  var FEE_VARIANT = script && Number(script.dataset.feeVariant);
  var FEE_HANDLE = 'fee-rule';
  var SOORT = 'hard seltzer';

  if (!FEE_VARIANT) return;

  function isFee(item) {
    return item.handle === FEE_HANDLE || item.variant_id === FEE_VARIANT;
  }

  function isPack(item) {
    return String(item.product_type || '').toLowerCase() === SOORT;
  }

  function json(url, body) {
    return fetch(url, body ? {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    } : { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(url + ' gaf ' + r.status);
      return r.json();
    });
  }

  function root() {
    return (window.routes && window.routes.root_url ? window.routes.root_url : '/').replace(/\/?$/, '/');
  }

  /* Wat Dawn na een wijziging opnieuw tekent: de lijst komt van zijn eigen
     elementen (cart-drawer-items in de drawer, cart-items op de cartpagina),
     zodat we precies hetzelfde verversen als Dawn zelf doet. */
  function dawnSecties() {
    var defs = [];
    var gezien = {};
    document.querySelectorAll('cart-items, cart-drawer-items').forEach(function (el) {
      if (typeof el.getSectionsToRender !== 'function') return;
      el.getSectionsToRender().forEach(function (def) {
        if (!def.section || gezien[def.section]) return;
        gezien[def.section] = true;
        defs.push({ def: def, el: el });
      });
    });
    return defs;
  }

  /* Opnieuw tekenen is geen netheid maar noodzaak. Shopify zet een nieuwe
     regel bovenaan de mand, dus komt het statiegeld erbij nadat de mand
     getekend is, dan schuift elk pack een plek op. Dawn wijzigt regels op
     volgnummer (line), en het minnetje bij het 12 pack veranderde dan het
     statiegeld. Na het verversen kloppen de nummers weer. */
  function teken(defs, sections) {
    if (!sections) return;
    defs.forEach(function (d) {
      var html = sections[d.def.section];
      var host = document.getElementById(d.def.id);
      if (!html || !host) return;
      var doel = host.querySelector(d.def.selector) || host;
      try {
        doel.innerHTML = d.el.getSectionInnerHTML(html, d.def.selector);
      } catch (err) {
        console.warn('Statiegeld: sectie ' + d.def.section + ' niet ververst', err);
      }
    });
  }

  function alsRegel(item) {
    var regel = { id: item.variant_id, quantity: item.quantity };
    if (item.properties && Object.keys(item.properties).length) regel.properties = item.properties;
    if (item.selling_plan_allocation) regel.selling_plan = item.selling_plan_allocation.selling_plan.id;
    return regel;
  }

  /* Statiegeld als oudste regel, de rest erboven in de volgorde van nu.
     Tussen het leegmaken en het toevoegen is de mand even leeg; weigert
     Shopify het toevoegen in één keer (bijvoorbeeld omdat iets intussen
     uitverkocht is), dan gaan de regels er één voor één in, zodat de rest
     er in elk geval weer in staat. */
  function opnieuwOpbouwen(cart, want, extra) {
    var producten = cart.items.filter(function (item) { return !isFee(item); });
    var regels = [{ id: FEE_VARIANT, quantity: want }].concat(producten.slice().reverse().map(alsRegel));
    var nul = {};
    cart.items.forEach(function (item) { nul[item.key] = 0; });

    return json(root() + 'cart/update.js', { updates: nul })
      .then(function () {
        return json(root() + 'cart/add.js', Object.assign({ items: regels }, extra));
      })
      .catch(function (err) {
        console.warn('Statiegeld: mand in één keer opbouwen lukte niet, regel voor regel', err);
        return regels.reduce(function (keten, regel) {
          return keten.then(function () {
            return json(root() + 'cart/add.js', { items: [regel] }).catch(function (e) {
              console.warn('Statiegeld: regel niet terug in de mand', regel, e);
            });
          });
        }, Promise.resolve()).then(function () {
          return json(root() + 'cart/update.js', Object.assign({ updates: {} }, extra));
        });
      });
  }

  /* Eén ronde: mand ophalen, tellen, en alleen als het niet klopt iets
     wijzigen. Geeft de mand terug zoals hij daarna is. */
  function once() {
    return json(root() + 'cart.js').then(function (cart) {
      var want = 0;
      var fees = [];
      cart.items.forEach(function (item) {
        if (isFee(item)) fees.push(item);
        else if (isPack(item)) want += item.quantity;
      });
      var have = fees.reduce(function (s, f) { return s + f.quantity; }, 0);

      var opZijnPlek = fees.length === 1 && cart.items[cart.items.length - 1] === fees[0];
      if (want === 0 ? !fees.length : opZijnPlek && have === want) return cart;

      var defs = dawnSecties();
      var extra = {
        sections: defs.map(function (d) { return d.def.section; }),
        sections_url: window.location.pathname
      };

      if (want > 0 && !opZijnPlek) {
        return opnieuwOpbouwen(cart, want, extra).then(function (res) {
          teken(defs, res && res.sections);
          return json(root() + 'cart.js');
        });
      }

      /* De eerste statiegeldregel krijgt het goede aantal, eventuele
         dubbele gaan op 0. Op regelsleutel, zodat het in één verzoek kan.
         Hier tekenen we níét opnieuw: het statiegeld staat al onderaan, dus
         een ander aantal (of weghalen) verschuift geen regelnummer, en de
         drawer toont het statiegeld niet. Opnieuw tekenen verving het
         aantal-veld terwijl iemand nog aan het tikken was: tikken gingen
         verloren en het getal sprong terug (eigenaar, gemeten: vijf keer +
         eindigde op 4 in plaats van 6). */
      var updates = {};
      fees.forEach(function (f, i) { updates[f.key] = i === 0 ? want : 0; });
      return json(root() + 'cart/update.js', { updates: updates });
    });
  }

  var bezig = null;
  var nogEens = false;

  function sync() {
    if (bezig) {
      nogEens = true;
      return bezig;
    }
    bezig = once()
      .catch(function (err) {
        console.warn('Statiegeld gelijktrekken, tweede poging:', err);
        return once();
      })
      .then(function (cart) {
        markeerLeeg(cart);
        return cart;
      })
      .finally(function () {
        bezig = null;
        if (nogEens) {
          nogEens = false;
          sync();
        }
      });
    return bezig;
  }

  /* Dawn zet `is-empty` op item_count, en daar telt het statiegeld in mee.
     Haalt iemand het laatste 12 pack weg, dan toont de Liquid al de lege
     stand maar blijft de klasse eraf; die zetten we hier recht. */
  function markeerLeeg(cart) {
    if (!cart || !cart.items) return;
    var leeg = !cart.items.some(function (item) { return !isFee(item); });
    if (!leeg) return;
    ['cart-drawer', 'cart-items', '#main-cart-footer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) el.classList.add('is-empty');
    });
  }

  /* De afrekenknoppen (drawer en cartpagina): eerst vers gelijktrekken,
     dan pas door. Wat er ook misgaat, de klant komt in de checkout. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('loading');
    var door = function () { window.location.href = root() + 'checkout'; };
    /* Loopt er al een ronde, dan daarna nog een verse: die eerste kan zijn
       begonnen vóór de laatste wijziging aan de mand. */
    (bezig || Promise.resolve()).then(function () { return sync(); }).then(door, door);
  }, true);

  /* Na elke wijziging aan de mand. Ons eigen gelijktrekken meldt zich niet
     bij Dawn, dus dit loopt niet rond. Let op: Dawn declareert
     PUB_SUB_EVENTS met `const` (constants.js), dus het staat in de
     gedeelde scope en níét op window; `window.PUB_SUB_EVENTS` is altijd
     undefined. */
  function haakIn() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { sync(); });
    }
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', haakIn);
  else haakIn();

  /* Terug met de terugknop: Safari zet de pagina terug uit zijn bfcache,
     met de mand zoals hij was (terug uit de checkout, of na iets toevoegen
     op een productpagina) en een afrekenknop die nog op "bezig" kan staan.
     Dit herlaadde eerst de hele pagina, maar dan begint Safari bovenaan en
     ben je kwijt waar je was (eigenaar: van een productpagina terug naar de
     homepage). Nu halen we alleen de mand vers op en tekenen we de drawer
     en het icoon opnieuw, dezelfde secties die Dawn na een toevoeging
     tekent. Alleen de cartpagina zelf herladen we nog: daar is de mand de
     hele pagina. */
  function ververs() {
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(function (btn) {
      btn.removeAttribute('aria-busy');
      btn.classList.remove('loading');
    });
    if (document.querySelector('cart-items')) {
      window.location.reload();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    var defs = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender() : [];
    var opgehaald = !defs.length ? Promise.resolve() : fetch(
      root() + '?sections=' + defs.map(function (d) { return d.id; }).join(','),
      { headers: { Accept: 'application/json' } }
    ).then(function (r) {
      if (!r.ok) throw new Error('secties ' + r.status);
      return r.json();
    }).then(function (sections) {
      defs.forEach(function (d) {
        var el = d.selector ? document.querySelector(d.selector) : document.getElementById(d.id);
        if (el && sections[d.id]) el.innerHTML = drawer.getSectionInnerHTML(sections[d.id], d.selector);
      });
      /* de overlay is vervangen, dus ook zijn klik om te sluiten */
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
    });
    opgehaald
      .catch(function (err) { console.warn('Mand verversen na terug:', err); })
      .then(function () { return sync(); })
      .then(function (cart) {
        if (drawer && cart && cart.items) {
          drawer.classList.toggle('is-empty', !cart.items.some(function (item) { return !isFee(item); }));
        }
      });
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) ververs(); });
})();
